import React from "react";
import './RateBox.css'

const RateBox = ({ type, rate, difference, symbol }) => {
  return (
    <>
      <div className="rate-box">
        <div className="content">
          <h3>{type}</h3>
          <p>₹ {rate}</p>
          <div className={`difference-price ${symbol}`}>
            <span>{difference}</span>
            <img src={`/img/${symbol}.svg`} alt="" />
          </div>
        </div>
      </div>
    </>
  )
}

export default RateBox;